export default __webpack_public_path__ + "static/media/logo.15377bc4.svg";